import { AudioLevelAnalyser } from '../analysers/audio-level-analyser';

export const getDiagnosticAudioLevelAnalyzer = (() => {
    let diagnosticAnalyzer: Maybe<AudioLevelAnalyser>;
    return (audioContext: Maybe<AudioContext>) => {
        if (!audioContext) {
            return;
        }
        if (diagnosticAnalyzer) {
            return diagnosticAnalyzer;
        }
        diagnosticAnalyzer = new AudioLevelAnalyser(audioContext);
        return diagnosticAnalyzer;
    };
})();
